import { createFileRoute, Link } from "@tanstack/react-router";
import { Suggestion, Suggestions } from "@/components/ai-elements/suggestion";
import { ConnectAiDocs } from "@/components/setup/connect-ai-docs";

export const Route = createFileRoute("/docs/quick-start")({
	component: QuickStart,
});

function QuickStart() {
	return (
		<article className="space-y-10">
			<div className="space-y-2">
				<h1 className="text-2xl font-medium tracking-tight">Quick start</h1>
				<p className="text-sm text-muted-foreground">
					Set up AgentReacher and connect Claude, ChatGPT, or your preferred AI
					model.
				</p>
			</div>

			<div className="space-y-4 text-sm leading-relaxed text-muted-foreground">
				<p>
					AgentReacher lets your AI create, schedule, and publish social posts
					through MCP.
				</p>
				<p>
					Connect your social accounts, then ask your assistant to draft posts,
					choose targets, schedule delivery, and report back. You stay in
					control through approvals, the calendar, and the web dashboard.
				</p>
				<p>
					The dashboard and MCP operate on the same workspace, so changes made
					by your assistant show up in AgentReacher immediately.
				</p>

				<h2 className="text-base font-medium text-foreground pt-2">
					Set up MCP
				</h2>
				<p>
					Connect AgentReacher to Claude, ChatGPT, or another MCP-compatible
					assistant.
				</p>
				<ConnectAiDocs />
				<p className="pt-2">Once connected, tell your assistant things like:</p>
				<Suggestions title="Example prompts">
					<Suggestion suggestion="Connect my X account." />
					<Suggestion suggestion="Create a post about our new feature and publish it to X and LinkedIn." />
					<Suggestion suggestion="Schedule a post for tomorrow at 9am." />
					<Suggestion suggestion="Show me what's scheduled for this week." />
				</Suggestions>
				<p>
					Your AI assistant calls AgentReacher&apos;s tools on your behalf. No
					dashboard required. See the{" "}
					<Link
						to="/docs/mcp"
						className="text-primary hover:text-primary/80 transition-colors"
					>
						MCP overview
					</Link>{" "}
					for more details.
				</p>

				<h2 className="text-base font-medium text-foreground pt-2">
					The dashboard
				</h2>

				<p>
					The web dashboard at{" "}
					<a
						href="https://agentreacher.com"
						className="text-primary hover:text-primary/80 transition-colors"
					>
						agentreacher.com
					</a>{" "}
					is your view layer. Use it to review posts, check the calendar, manage
					connections, and invite team members. All post creation, editing,
					scheduling, and publishing is available through MCP. We aim to strive
					for feature parity between MCP and the web dashboard.
				</p>
			</div>

			<div className="flex items-center gap-4 text-sm">
				<Link
					to="/docs/creating-posts"
					className="text-primary hover:text-primary/80 transition-colors ml-auto"
				>
					Creating posts &rarr;
				</Link>
			</div>
		</article>
	);
}
